module.exports = __webpack_public_path__ + "img/panama.4b2a6f4d.png";